import React from "react";

const Cancellation = () => {
  return (
    <main>
      {/* breadcrumb start */}
      <section id="h1-breadcrumb">
        <div className="h1-breadcrumb w-full h-fit overflow-hidden relative bg-main-gray pb-16 md:pb-[120px]">
          <img
            src="./assets/images/home-nine/hero-bg.png"
            alt=""
            className="absolute z-0 mx-auto cta_bg_anim h-full w-full"
          />

          <div
            className="win-grid win-grid-bg w-full h-full absolute left-0 top-0 z-0"
            id="win-grid"
          />
          <div className="absolute left-1/4 w-full top-[300px] overflow-hidden z-0 pointer-events-none">
            <div className="flex justify-center">
              <img src="assets/images/home-one-hero-circle-shadow.svg" alt="" />
            </div>
          </div>
          <div className="theme-container mx-auto h-fit w-fit relative z-0">
            <div className="mt-[120px] md:mt-[200px] w-fit mx-auto relative">
              <h1
                data-aos="fade"
                className="text-main-black text-34 font-semibold w-full text-center max-w-[500px]"
              >
                Cancellation Policy
              </h1>
            </div>
          </div>
        </div>
      </section>
      {/* breadcrumb end */}

      {/* blog start  */}
      <section className="w-full py-16 md:py-[130px]" data-aos="fade">
        <div className="theme-container mx-auto w-full text-paragraph">
          <i className="text-[14px] mb-2 inline-block font-semibold">
            Last updated on Jan 29th 2025
          </i>
          <p className="font-medium mb-2">
            ClickForDoctor believes in helping its customers as far as possible,
            and has therefore a liberal cancellation policy. Under this policy:
          </p>
          <ul>
            <li className="mb-2">
              1. Cancellations will be considered only if the request is made
              within 7 days of placing the order. However, the cancellation
              request may not be entertained if the orders have been
              communicated to the vendors/merchants and they have initiated the
              process of shipping / delivering / Using them.
            </li>
            <li className="mb-2">
              2. ClickForDoctor does not accept cancellation requests for orders
              already initiated or in transit or completed. However,
              refund/replacement can be made if the customer establishes that
              the quality of product/service delivered is not good.
            </li>
            <li className="mb-2">
              3. In case of improper delivery of services or inaccurate results,
              please report the same to our Customer Service team. The request
              will, however, be entertained once the health provider has checked
              and determined the same at his own end. This should be reported
              within 7 days of receipt of the product/service.
            </li>
            <li className="mb-2">
              4. In case you feel that the product/service received is not as
              promised by us or as per your expectations, you must bring it to
              the notice of our customer service within 7 days of receiving the
              product/service. The Customer Service Team after looking into your
              complaint will take an appropriate decision.
            </li>
            <li className="mb-2">
              5. In case of any Refunds approved by the ClickForDoctor, it’ll
              take 6-8 days for the refund to be processed to the end customer.
            </li>
            <li className="mb-2">
              6. In the event that a User/ costumer requests a refund but the
              service has already been initiated or not cancelled in time, the
              fee shall be non-refundable. This fee is charged by a third-party
              logistics partner and cannot be reclaimed once the service is
              booked. If the service or plan is not cancelled, or if
              cancellation is not possible due to the service already being
              dispatched or delivered, the corresponding amount will be deducted
              from the total refundable amount.
            </li>
          </ul>
        </div>
      </section>
      {/* blog end  */}
    </main>
  );
};

export default Cancellation;
